module.exports = __webpack_public_path__ + "img/360.e90fff13.svg";